import { Component, Input, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import Swal from 'sweetalert2';
import { MenuToggleService } from '../side-nav.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css'],
})
export class SideBarComponent implements OnInit {
  user: any;
  isCollapsed = false;
  isSideNavOpen: boolean = true;
  userName: string;
  businessUserName:string ;
  modalRef: NgbModalRef;
  userObject: any = null;
  @ViewChild('profileInactiveModal', { static: true }) profileInactiveModal: TemplateRef<any>;
  // @Input() user: any;
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private menuToggleService: MenuToggleService,
    private modalService: NgbModal
  ) {
    this.menuToggleService.isSideNavOpen$.subscribe(isOpen => {
      this.isSideNavOpen = isOpen;
    });
    // Re-evaluate user active status on navigation changes (handles logout/login flow)
    this.router.events.subscribe(evt => {
      if (evt instanceof NavigationEnd) {
        // Defer to allow auth/localStorage updates to settle after navigation
        setTimeout(() => this.evaluateProfileActive());
      }
    });
  }

  ngOnInit(): void {
    this.evaluateProfileActive();
  }
ngAfterViewInit(): void {
  // Defer evaluation to ensure view is stable
  setTimeout(() => this.evaluateProfileActive());
}
  private evaluateProfileActive() {
    // Prefer server truth to avoid stale token payload after login
    this.authenticationService.getProfile().subscribe({
      next: (res: any) => {
        const serverUser = res?.data || {};
        // Merge into localStorage for consistency with Header
        const storedUserStr = localStorage.getItem('merchant_currentUser1');
        let storedUser: any = {};
        if (storedUserStr) {
          try { storedUser = JSON.parse(storedUserStr) || {}; } catch { storedUser = {}; }
        }
        const updatedUser = { ...storedUser, ...serverUser };
        this.userObject = updatedUser;
        if (this.userObject?.name) {
          this.businessUserName = this.userObject.name;
        }
        const isActiveVal = this.userObject?.isActive;
        const inactive = this.userObject && (isActiveVal === false || isActiveVal === 'false' || isActiveVal === '' || isActiveVal == null);
        if (inactive) {
          setTimeout(() => this.openProfileInactiveModal());
        } else if (this.modalRef) {
          try { this.modalRef.close(); } catch {}
          this.modalRef = null as any;
        }
      },
      error: () => {
        // Fallback to localStorage if server fails
        this.user = localStorage.getItem('merchant_id');
        const storedUser = localStorage.getItem('merchant_currentUser1');
        try {
          this.userObject = storedUser ? JSON.parse(storedUser) : null;
        } catch (e) {
          this.userObject = null;
        }
        if (this.userObject?.name) {
          this.businessUserName = this.userObject.name;
        }
        const isActiveVal = this.userObject?.isActive;
        const inactive = this.userObject && (isActiveVal === false || isActiveVal === 'false' || isActiveVal === '' || isActiveVal == null);
        if (inactive) {
          setTimeout(() => this.openProfileInactiveModal());
        } else if (this.modalRef) {
          try { this.modalRef.close(); } catch {}
          this.modalRef = null as any;
        }
      }
    });
  }
  openProfileInactiveModal() {
    if (this.modalRef) {
      return;
    }
    // Re-validate current active state right before opening
    const storedUser = localStorage.getItem('merchant_currentUser1');
    try {
      this.userObject = storedUser ? JSON.parse(storedUser) : null;
    } catch (e) {
      this.userObject = null;
    }
    const isActiveVal = this.userObject?.isActive;
    const inactiveNow = this.userObject && (isActiveVal === false || isActiveVal === 'false' || isActiveVal === '' || isActiveVal == null);
    if (!inactiveNow) {
      // Do not open if user is now active
      return;
    }
    if (this.profileInactiveModal) {
      this.modalRef = this.modalService.open(this.profileInactiveModal, {
        centered: true,
        backdrop: 'static',
        keyboard: false,
        windowClass: 'profile-inactive-modal'
      });
    }
  }

  activateProfile(modal: any) {
    this.authenticationService.activateUser().subscribe({
      next: (response) => {
        // Update localStorage with isActive: true
        const storedUser = localStorage.getItem('merchant_currentUser1');
        if (storedUser) {
          const userObject = JSON.parse(storedUser);
          userObject.isActive = true;
          localStorage.setItem('merchant_currentUser1', JSON.stringify(userObject));
        }
        modal.close();
        Swal.fire('', 'Your profile has been activated successfully!', 'success');
      },
      error: (error) => {
        Swal.fire('', 'Failed to activate profile. Please try again.', 'error');
      }
    });
  }
  hideSideNav(){
    this.isSideNavOpen = false;
    this.menuToggleService.toggleSideNav();
  }
  logout() {
    if (this.modalRef) {
      try { this.modalRef.close(); } catch {}
      this.modalRef = null as any;
    }
    this.userObject = null;
    this.router.navigateByUrl('/login');
    this.authenticationService.logout();
  }

  ngOnChanges() {

  }

  redirectTo(type: any) {
    if (this.user) {
      if (type == 1) {
        if (this.user.hasSubscription == true) {
          Swal.fire('', 'You already have subscribed to base plan', 'success');
        } else {
          this.router.navigate(['/plans'], { queryParams: { isSub: true } });
        }
      } else if (type == 2 && this.user.isFirstUpdateDone == true) {
        this.router.navigate(['/update-profile']);
      }
    }
  }

  porfileUpdate() {
    this.router.navigate(['/update-profile'])
    this.authenticationService.setIsProfileUpdate(true);
  }

  goToUrl(): void {
   window.open('https://personal.ravel.faith/', '_blank');
  }

  support(){
    window.open('https://triadmobilenetworks.com/contact-us/', '_blank');
  }

  sendEmail() {
    var subject = "Follow us at the Trade-in-Faith Marketplace on Ravel!";
    // var merchantProfileLink = `https://merchant.ravel.faith/#/detail-page?keyword=Business&id=${this?.user}`;
    var merchantProfileLink = `https://merchant.ravel.faith/#/profile/${this?.businessUserName}`;
    var ravelLink = "https://Ravel.Faith"
    var emailBody = `Hello,

Check out our profile in the Trade-in-Faith Marketplace, the Christian business directory on Ravel.
Ravel is the place where Christians can worship, chat, pray, shop & save!

• ${merchantProfileLink}

Not on Ravel yet? Start your free profile and follow us to earn Ravel Reward Points! Go to:

• https://personal.ravel.faith/

Download the app:

• IOS - https://apps.apple.com/us/app/ravel/id1463946465
• Android - https://play.google.com/store/apps/details?id=ravel.faith&pcampaignid=web_share

See you on Ravel!

Blessings,
${this?.businessUserName}`;


    // Encode line breaks for the email body
    emailBody = encodeURIComponent(emailBody).replace(/%0A/g, '%0D%0A');

    // Create mailto link
    var mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${emailBody}`;

    // Open the default email client
    window.location.href = mailtoLink;

    // window.location.href = "mailto:" + "pawan@geekinformatic.com" + "?subject=" + subject + "&body=" + encodeURIComponent(emailBody);

  }

  urlify(text: any) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function(url: string) {
      return `<a href="${url}" target="_blank">${url}</a>`;
    })
  }


}
